import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import { SnackbarProvider } from "notistack";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import "./i18n";
import "./global.css";
import PrivateRoute from "./components/PrivateRoute";

// Pages
import { Login, Dashboard, Profile } from "./pages";

// Admin Components
import AdminSettings from "./components/admin/Settings";
import ESIMOrderManager from "./components/admin/ESIMOrderManager";
import ResellerManagement from "./components/admin/reseller/ResellerManagement";
import TransactionManager from "./components/admin/TransactionManager";
import EmailTemplateManager from "./components/admin/EmailTemplateManager";
import AdminDashboard from "./components/admin/Dashboard";

import Layout from "./components/Layout";
import PublicLayout from "./components/PublicLayout";
import AuthGuard from "./components/AuthGuard";

import TopUpCredits from "./components/TopUpCredits";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import MockCheckout from "./components/MockCheckout";
import ESIMManagement from "./pages/ESIMManagement";
import TransactionHistory from "./components/Transaction/TransactionHistory";
import ESIMOrders from "./components/ESIMOrders";
import Register from "./pages/Register";
import EmailVerification from "./pages/EmailVerification";
import ResellerDetailView from "./components/admin/reseller/ResellerDetailView";

function App() {

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
        <CssBaseline />
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        >
          <BrowserRouter>
            <AuthGuard>
              <Routes>
                {/* Public Routes */}
                <Route element={<PublicLayout />}>
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route
                    path="/verify-email/:token"
                    element={<EmailVerification />}
                  />
                </Route>
                {/* Private Routes */}
                <Route path="/" element={<Layout />}>
                  <Route
                    index
                    element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/esim"
                    element={
                      <PrivateRoute>
                        <ESIMManagement />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/orders"
                    element={
                      <PrivateRoute>
                        <ESIMOrders />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="topup"
                    element={
                      <PrivateRoute>
                        <TopUpCredits />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="payment/success"
                    element={
                      <PrivateRoute>
                        <PaymentSuccess />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="payment/cancel"
                    element={
                      <PrivateRoute>
                        <PaymentCancel />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/mock-checkout/:sessionId"
                    element={<MockCheckout />}
                  />
                  <Route
                    path="transactions"
                    element={
                      <PrivateRoute>
                        <TransactionHistory />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="profile"
                    element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    }
                  />
                  {/* Admin Routes */}
                  <Route path="admin">
                    <Route
                      index
                      element={
                        <PrivateRoute requireAdmin>
                          <AdminDashboard />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="resellers/:id"
                      element={
                        <PrivateRoute requireAdmin>
                          <ResellerDetailView />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="settings"
                      element={
                        <PrivateRoute requireAdmin>
                          <AdminSettings />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="esim-orders"
                      element={
                        <PrivateRoute requireAdmin>
                          <ESIMOrderManager />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="resellers"
                      element={
                        <PrivateRoute requireAdmin>
                          <ResellerManagement />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="transactions"
                      element={
                        <PrivateRoute requireAdmin>
                          <TransactionManager />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="email-templates"
                      element={
                        <PrivateRoute requireAdmin>
                          <EmailTemplateManager />
                        </PrivateRoute>
                      }
                    />
                  </Route>
                </Route>
              </Routes>
            </AuthGuard>
          </BrowserRouter>
        </GoogleReCaptchaProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
